import { Routes } from '@angular/router';
import { routerSegments } from './consts/routes';
import { LayoutComponent } from './components/layout/layout.component';
import { authenticatedGuard } from './guards/authenticated.guard';
import { permissionGuard } from './guards/permission.guard';
import { PermissionAccessModels } from './models/permission-access.model';
import { PermissionModels } from '@share-models';
import { ReportsComponent } from './pages/reports/reports.component';
import { PublicAccessDeniedPageComponent, PublicEmailVerificationPageComponent, PublicResetPasswordPageComponent } from '@auth';
import { WallsListComponent } from './pages/walls-list/walls-list.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: routerSegments.home,
    pathMatch: 'full',
  },
  {
    path: routerSegments.home,
    loadComponent: () => LayoutComponent,
    canActivate: [authenticatedGuard],
    children: [
      {
        path: routerSegments.walls,
        loadComponent: () => WallsListComponent,
      },
      {
        path: routerSegments.reports,
        loadComponent: () => ReportsComponent,
      },
      {
        path: routerSegments.sops,
        canActivate: [permissionGuard],
        data: {
          [PermissionAccessModels.RouteDataKey.Permissions]: [
            PermissionModels.Permissions.ControlCenterSopRead,
          ],
        },
        loadComponent: () =>
          import('./pages/sops/sops-list.component').then(
            (m) => m.SopsListComponent,
          ),
      },
      {
        path: routerSegments.verificationStatistics,
        loadComponent: () =>
          import(
            './pages/verification-statistics/verification-statistics.component'
          ).then((m) => m.VerificationStatisticsComponent),
      },
      {
        path: '',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
        data: {
          breadcrumb: 'HOME.TITLE',
        }
      },
    ],
  },
  {
    path: routerSegments.accountDetails,
    loadComponent: () => LayoutComponent,
    canActivate: [authenticatedGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/account-details/account-details.component').then(
            (m) => m.AccountDetailsComponent,
          ),

      },
    ],
  },
  {
    path: routerSegments.logout,
    redirectTo: '',
    pathMatch: 'full',
  },
  {
    path: routerSegments.resetPassword,
    component: PublicResetPasswordPageComponent,
  },
  {
    path: routerSegments.emailVerification,
    component: PublicEmailVerificationPageComponent,
  },
  {
    path: routerSegments.accessDenied,
    component: PublicAccessDeniedPageComponent,
  },
  {
    path: routerSegments.notFound,
    loadChildren: () =>
      import('./pages/not-found/not-found.routes').then(
        (m) => m.notFoundRoutes,
      ),
  },
  {
    path: routerSegments.wallView,
    loadComponent: () =>
      import('./pages/wall-view/wall-view.component').then(
        (m) => m.WallViewComponent,
      ),
    canActivate: [authenticatedGuard],
  },
  {
    path: '**',
    redirectTo: routerSegments.home,
  },
];
